const PRODUCT_COPY = {
  CIBCITripProTripCan: { category: "text.quotecategory_tcti", fullName: "text.quotefullname_tcti", description: "text.quotedescription_tcti", exclusion: "text.quoteexclusion_tcti" },
  CIBCTripProTripCan: { category: "text.quotecategory_tcti", fullName: "text.quotefullname_tcti", description: "text.quotedescription_tcti", exclusion: "text.quoteexclusion_tcti" },
  CIBCIComprehensive: {
    category: "text.quotecategory_comprehensive",
    fullName: "text.quotefullname_comprehensive",
    description: "text.quotedescription_comprehensive",
    benefits: [
      "text.quotebenefit_comprehensive_medical",
      "text.quotebenefit_comprehensive_tcti",
      "text.quotebenefit_comprehensive_baggage"
    ],
    select: "text.quotecomprehensive_select",
    moreDetails: "text.quotecomprehensive_moredetails"
  },
  CIBCComprehensive: {
    category: "text.quotecategory_comprehensive",
    fullName: "text.quotefullname_comprehensive",
    description: "text.quotedescription_comprehensive",
    benefits: [
      "text.quotebenefit_comprehensive_medical",
      "text.quotebenefit_comprehensive_tcti",
      "text.quotebenefit_comprehensive_baggage"
    ],
    select: "text.quotecomprehensive_select",
    moreDetails: "text.quotecomprehensive_moredetails"
  },
  CIBCIMedicalPlan: { category: "text.quotecategory_medicalsingle", fullName: "text.quotefullname_medicalsingle", description: "text.quotedescription_medicalsingle", exclusion: "text.quoteexclusion_medicalsingle" },
  CIBCMedicalPlan: { category: "text.quotecategory_medicalsingle", fullName: "text.quotefullname_medicalsingle", description: "text.quotedescription_medicalsingle", exclusion: "text.quoteexclusion_medicalsingle" },
  CIBCIAnnual8Day: { category: "text.quotecategory_annual8", fullName: "text.quotefullname_annual8", description: "text.quotedescription_annual8", exclusion: "text.quoteexclusion_annual8", benefits: ["text.quotebenefit_annual_unlimited8", "text.quotebenefit_medical", "text.quotebenefit_annual_hospital"] },
  CIBCAnnual8Day: { category: "text.quotecategory_annual8", fullName: "text.quotefullname_annual8", description: "text.quotedescription_annual8", exclusion: "text.quoteexclusion_annual8", benefits: ["text.quotebenefit_annual_unlimited8", "text.quotebenefit_medical", "text.quotebenefit_annual_hospital"] },
  CIBCIAnnual18Day: { category: "text.quotecategory_medical18", fullName: "text.quotefullname_annual18", description: "text.quotedescription_medical18", exclusion: "text.quoteexclusion_medical18", benefits: ["text.quotebenefit_annual_unlimited18", "text.quotebenefit_medical", "text.quotebenefit_annual_hospital"] },
  CIBCAnnual18Day: { category: "text.quotecategory_medical18", fullName: "text.quotefullname_annual18", description: "text.quotedescription_medical18", exclusion: "text.quoteexclusion_medical18", benefits: ["text.quotebenefit_annual_unlimited18", "text.quotebenefit_medical", "text.quotebenefit_annual_hospital"] }
};

export default function getQuotePlanCopy(productCode) {
  return PRODUCT_COPY[productCode] || {};
}
